<template>
  <div>
    <div class='table' v-if="!loadingData && serverData">
      <div class='table__item table__item-header left-line right-line bottom-line without-line3 text-center'>
        Уровень программ
      </div>
      <div class='table__item table__item-header right-line bottom-line without-line4 text-center'>Форма</div>
      <div class='table__item table__item-header right-line text-center without-line'>
        Численность студентов, обучающихся на условиях общего приема (без учета численности студентов – иностранных
        граждан и лиц без гражданства, в том числе соотечественников, проживающих за рубежом, обучающихся в соответствии
        с установленной Правительством Российской Федерации квотой на образование иностранных граждан и лиц без
        гражданства в Российской Федерации), человек
      </div>
      <div class='table__item table__item-header right-line text-center'>
        Численность студентов – граждан Российской Федерации, обучающихся на условиях общего приема, человек
      </div>
      <div class='table__item table__item-header right-line without-line2 text-center'>
        Численность иностранных граждан и лиц без гражданства, в том числе соотечественников, проживающих за рубежом,
        обучающихся в соответствии с установленной Правительством Российской Федерации квотой, человек
      </div>
      
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-3}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-2}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-1}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-1}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-3}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line text-center'>на 01.10.{{baseYear-2}} г.</div>
      <div class='table__item table__item-header right-line bottom-line top-line'>на 01.10.{{baseYear-1}} г.</div>
      
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center left-line'>1</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center' style="min-width: 150px">2
      </div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>3</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>4</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>5</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>6</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>7</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>8</div>
      <div class='table__item pa-0 table__item-header right-line bottom-line text-center'>9</div>
      
      <div class='table__item bottom-line left-line text-center' style="grid-row: span 3">Бакалавриат</div>
      <div class='table__item right-line bottom-line left-line text-center'>очная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(0,7)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <!--      <div class='table__item right-line bottom-line left-line'></div>-->
      <div class='table__item right-line bottom-line left-line text-center'>очно-заочная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(7,14)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <!--      <div class='table__item right-line bottom-line left-line'></div>-->
      <div class='table__item right-line bottom-line left-line text-center left-line'>заочная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(14,21)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      
      <div class='table__item bottom-line left-line text-center' style="grid-row: span 3">Специалитет</div>
      <div class='table__item right-line bottom-line left-line text-center'>очная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(21,28)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      
      <!--      <div class='table__item right-line bottom-line left-line'></div>-->
      <div class='table__item right-line bottom-line left-line text-center'>очно-заочная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(28,35)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <!--      <div class='table__item right-line bottom-line left-line'></div>-->
      <div class='table__item right-line bottom-line left-line text-center'>заочная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(35,42)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <div class='table__item left-line text-center' style="grid-row: span 3">Магистратура</div>
      <div class='table__item right-line bottom-line left-line text-center'>очная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(42,49)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <!--      <div class='table__item right-line bottom-line left-line'></div>-->
      <div class='table__item right-line bottom-line left-line text-center'>очно-заочная форма</div>
      <div
        class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
        v-for="item in dataFields.slice(49,56)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
      
      <!--      <div class='table__item right-line left-line'></div>-->
      <div class='table__item right-line left-line text-center '>заочная форма</div>
      <div class='table__item  right-line item-data text-center d-flex flex-row align-center justify-space-around'
           v-for="item in dataFields.slice(56,63)" :key="item.name">
        <fives-table-cell
          style="flex: 1 0"
          :disabled="organizationBlocked"
          v-bind="calcPropsForCell(item.name)"
          @open-dialog="openDialog($event, item.name)"/>
        <v-btn small icon @click="openTooltip(item.name)">
          <v-icon
            :size="15"
            class="grey-light-color__important "
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div v-else-if="loadingData" class="d-flex flex-row align-center justify-center" style="min-width: 150px;">
      <v-progress-linear indeterminate/>
    </div>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
  </div>
</template>

<script>
import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import FivesTableCell from "@/components/fields/fivesTableCell";
import appealDialog from "@/components/Dialogs/appealForms5_1-4Dialog";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "form5-3",
  mixins: [setAppealFromOneToFourDialog, headerTooltipFunctions, fiveFormsMixin],
  components: {FivesTableCell, appealDialog, tooltipForms5Dialog},
  props: {
    baseYear: {
      type: Number,
      required: true
    },
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      serverData: null,
      loadingData: false,
      loadingMenu: {value: false, id: ''},
      dataFields: [
        {name: "nsbco20Vp1"},
        {name: "nsbco21Vp1"},
        {name: "nsbco22Vp1"},
        {name: "nrbco22Vp1"},
        {name: "nqbco20Vp1"},
        {name: "nqbco21Vp1"},
        {name: "nqbco22Vp1"},
        
        {name: "nsbcv20Vp1"},
        {name: "nsbcv21Vp1"},
        {name: "nsbcv22Vp1"},
        {name: "nrbcv22Vp1"},
        {name: "nqbcv20Vp1"},
        {name: "nqbcv21Vp1"},
        {name: "nqbcv22Vp1"},
        
        {name: "nsbcz20Vp1"},
        {name: "nsbcz21Vp1"},
        {name: "nsbcz22Vp1"},
        {name: "nrbcz22Vp1"},
        {name: "nqbcz20Vp1"},
        {name: "nqbcz21Vp1"},
        {name: "nqbcz22Vp1"},
        
        {name: "nsspo20Vp1"},
        {name: "nsspo21Vp1"},
        {name: "nsspo22Vp1"},
        {name: "nrspo22Vp1"},
        {name: "nqspo20Vp1"},
        {name: "nqspo21Vp1"},
        {name: "nqspo22Vp1"},
        
        {name: "nsspv20Vp1"},
        {name: "nsspv21Vp1"},
        {name: "nsspv22Vp1"},
        {name: "nrspv22Vp1"},
        {name: "nqspv20Vp1"},
        {name: "nqspv21Vp1"},
        {name: "nqspv22Vp1"},
        
        {name: "nsspz20Vp1"},
        {name: "nsspz21Vp1"},
        {name: "nsspz22Vp1"},
        {name: "nrspz22Vp1"},
        {name: "nqspz20Vp1"},
        {name: "nqspz21Vp1"},
        {name: "nqspz22Vp1"},
        
        {name: "nsmgo20Vp1"},
        {name: "nsmgo21Vp1"},
        {name: "nsmgo22Vp1"},
        {name: "nrmgo22Vp1"},
        {name: "nqmgo20Vp1"},
        {name: "nqmgo21Vp1"},
        {name: "nqmgo22Vp1"},
        
        {name: "nsmgv20Vp1"},
        {name: "nsmgv21Vp1"},
        {name: "nsmgv22Vp1"},
        {name: "nrmgv22Vp1"},
        {name: "nqmgv20Vp1"},
        {name: "nqmgv21Vp1"},
        {name: "nqmgv22Vp1"},
        
        {name: "nsmgz20Vp1"},
        {name: "nsmgz21Vp1"},
        {name: "nsmgz22Vp1"},
        {name: "nrmgz22Vp1"},
        {name: "nqmgz20Vp1"},
        {name: "nqmgz21Vp1"},
        {name: "nqmgz22Vp1"},
      ]
    }
  },
  created() {
    this.appealInfo.nameForm = 'FORM5_3'
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm("part3", false, false, this.chosenChildOrg?.id)
        this.loadingData = false;
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Нет данных',
          timeout: 5000
        })
        this.loadingData = false;
      }
    },
    calcPropsForCell(dataField) {
      return {
        value: this.serverData[dataField],
        title: '',
        cell: {dataField: dataField},
        id: this.serverData.id,
        row: this.serverData,
        loading: this.loading,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-columns: 2fr 3fr repeat(7, minmax(100px, 150px));
  color: #89A0B0;
  background-color: #FFFFFF;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgb(0 0 0 / 6%);
  margin-bottom: 20px;
  overflow: auto;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
}

.table__item-header {
  font-size: 12px;
}

.table__item {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #CFD8DC;
  
  &:not(.table__item-header) {
    color: #455A64
  }
}

.table__header {
  border-top: 1px solid #CFD8DC;
}

.top-line {
  border-top: none;
}

.left-line {
  border-left: none;
}

.bottom-line {
  border-bottom: none;
}

.right-line {
  border-right: none;
}

.without-line {
  grid-column-start: 3;
  grid-column-end: 6;
}

.without-line2 {
  grid-column-start: 7;
  grid-column-end: 10;
}

.without-line3 {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;
}

.without-line4 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
}

.item-data:hover {
  background: rgba(207, 224, 236, 0.42);
}
</style>